import headerPage from '../components/headerPage.vue';
import footerPage from '../components/footerPage.vue';
import { ElConfigProvider } from 'element-plus';
import zhCn from 'element-plus/dist/locale/zh-cn.mjs';
import Tooltip from '@/components/Tooltip.vue';
export default {
  components: {
    headerPage,
    footerPage,
    ElConfigProvider,
    Tooltip
  },
  setup() {},
  data() {
    return {
      locale: zhCn
    };
  },
  mounted() {
    const token = localStorage.getItem('token');
    var inviteId = this.$route.query.inviteId || '';
    sessionStorage.setItem('inviteId', inviteId);
    //存在推广邀请人Id并且该用户未登录，拉起登录注册
    if (inviteId && !token) {
      this.$login().then(res => {
        console.log('登录成功', res);
      }).catch(err => {
        console.log('登录失败', err);
      });
    }
    this.getData();
  },
  methods: {
    getData() {
      // this.$service.HttpApiIndexCollectRecommend().then((res) => {});
    }
  }
};